module.exports = __webpack_public_path__ + "static/media/icono_contrasenia.485df3c7.svg";